import { render } from "./ConsciousSedation.vue?vue&type=template&id=35891f32"
import script from "./ConsciousSedation.vue?vue&type=script&lang=js"
export * from "./ConsciousSedation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__